import { Icon, Tooltip, IconButton } from "@material-ui/core";
import { useSnackbar } from "notistack";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import DenseAppBar from "../../components/AppBar";
import Filters from "../../components/Filters";
import PaginationControlled from "../../components/Pagination";
import Placeholder from "../../components/Skeleton";
import { Reducers } from "../../Interfaces/Interfaces";
import { getAdmins, queryAdmins } from "../../redux/actions/AdminActions";
import PrimaryTheme from "../../Themes/Primary";
import Button from "@material-ui/core/Button";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import Switch from "../../components/switch/switch";
import IdentityServices from "../../services/AuthService";
import { errorHandler } from "../../helpers/Functions";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
    },
  })
);
export default function Admin() {
  const classes = useStyles();

  const alert = useSelector((state: Reducers) => state.alert);
  const user = useSelector((state: Reducers) => state.user);

  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [searchState, setSearchState] = React.useState("");
  const [switchState, setswitchState] = React.useState(false);
  var administrators = useSelector((state: Reducers) => state.administrators);

  let list = administrators && administrators.items;

  let filter: any = {};
  const paginationConfig = {
    page: page + 1,
    pageSize,
    id: user.id,
    whereCondition: JSON.stringify(filter),
  };

  const getIndexSeed = (index: number) => {
    paginationConfig.page = page + 1;
    return (paginationConfig.page - 1) * paginationConfig.pageSize + index + 1;
  };

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handlePageSizeChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    value: any
  ) => {
    setPageSize(value.props.value);

    paginationConfig.pageSize = value.props.value;
    dispatch(queryAdmins(paginationConfig));
  };

  const handleRefresh = () => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    dispatch(getAdmins(paginationConfig));
  };

  React.useEffect(() => {
    dispatch({
      type: "LOADING",
      payload: true,
    });

    dispatch(getAdmins(paginationConfig));

    return () => {
      dispatch({
        type: "administrators",
        payload: {},
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, dispatch]);

  React.useEffect(() => {
    if (searchState.length >= 3) {
      filter.name = searchState;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({ type: "LOADING", payload: true });
      dispatch(getAdmins(paginationConfig));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchState]);

  const handleClear = () => {
    filter = {};
    paginationConfig.whereCondition = JSON.stringify(filter);

    setSearchState("");

    dispatch({
      type: "LOADING",
      payload: true,
    });

    // dispatch(getPOSDashboard(user.id));
    dispatch(getAdmins(paginationConfig));
  };

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });
      } else {
        handleRefresh();

        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert, history]);
  const handleRouteNewAgent = () => {
    history.push("/admins/add");
  };
  const handleSwitchAdmin = (value: any, userId: any) => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    let data = {
      userId,
    };
    const api = new IdentityServices().activateAndDeactivateAdminService(data);

    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: errorHandler(res),
              successful: false,
            },
          });
        }
      })
      .catch((err: any) => {
        dispatch({
          type: "ALERT",
          payload: {
            message: errorHandler(err),
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };

  return (
    <React.Fragment>
      <div
        className="col-md-11 mr-auto ml-auto p-0"
        style={{
          height: "auto",
          position: "relative",
        }}
      >
        <DenseAppBar />
      </div>
      <div
        className="col-md-12 pl-0 pr-0"
        style={{
          // overflow: "auto",
          backgroundColor: PrimaryTheme.white,
          minHeight: "100vh",
          height: "auto",
        }}
      >
        <div
          className="col-md-11 ml-auto mr-auto p-0"
          style={{
            backgroundColor: PrimaryTheme.white,
            height: "100vh",
            position: "relative",
            // zIndex: 1000,
          }}
        >
          <div className="col-md-12 p-0">
            <h1
              style={{
                fontFamily: PrimaryTheme.fonts?.MediumFont,
                textTransform: "uppercase",
                fontSize: PrimaryTheme.fontSizes?.subtitle,
              }}
            >
              Administrators
            </h1>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button
              onClick={handleRouteNewAgent}
              style={{
                border: "none",
                color: PrimaryTheme.primary,
                background: "transparent",
                marginBottom: 10,
              }}
            >
              <AddCircleIcon />
              <span
                style={{ color: "black", fontWeight: 700, marginBottom: 10 }}
                className="pb-10"
              >
                {" "}
                Add Admin
              </span>
            </button>
          </div>

          <div className="row ">
            <div className="col-md-12 mb-3">
              {list ? (
                <React.Fragment>
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead className="thead-primary">
                        <tr className="text-center">
                          <th>#</th>
                          <th>Full Name</th>
                          <th>Email</th>
                          <th>Phone Number</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.length !== 0 &&
                          list?.map((item: any, index: number) => (
                            <tr key={index} className="text-center">
                              <th scope="row">{getIndexSeed(index)}</th>
                              <td>
                                {item.firstName} {item.lastName}
                              </td>
                              <td>{item.emailAddress}</td>
                              <td>{item.phoneNumber}</td>
                              {item.isActive && (
                                <td>
                                  <Icon
                                    style={{
                                      color: PrimaryTheme.success,
                                    }}
                                  >
                                    check_all
                                  </Icon>
                                </td>
                              )}
                              {!item.isActive && (
                                <td>
                                  <Icon
                                    style={{
                                      color: PrimaryTheme.danger,
                                    }}
                                  >
                                    close
                                  </Icon>
                                </td>
                              )}
                              <td className="p-0">
                                {/* <Tooltip title="View">
                                <IconButton aria-label="View" onClick={() => history.push(`/admins/details/${item.userId}`)}>
                                  <Icon>visibility</Icon>
                                </IconButton>
                              </Tooltip> */}
                                <Tooltip title="Edit">
                                  <IconButton
                                    aria-label="Edit"
                                    onClick={() =>
                                      history.push(
                                        `/admins/edit/${item.userId}`
                                      )
                                    }
                                  >
                                    <Icon>edit</Icon>
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Switch">
                                  <IconButton aria-label="switch">
                                    <Switch
                                      onCheckeValue={handleSwitchAdmin}
                                      userId={item.userId}
                                      active={item.isActive}
                                    />
                                  </IconButton>
                                </Tooltip>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  {list.length === 0 && (
                    <React.Fragment>
                      <p className="text-center mt-3 text-dark w-100">
                        No result
                      </p>
                    </React.Fragment>
                  )}

                  <div className="col-md-12 p-0">
                    <PaginationControlled
                      onPageSizeChange={handlePageSizeChange}
                      onChange={handleChange}
                      page={page}
                      total={administrators.total && administrators.total}
                      pageSize={pageSize}
                    />
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
